type ScrollSync = {
  id: string
  element: HTMLElement
}

export class ScrollSyncUtils {
  syncGroup = new Map<string, ScrollSync[]>()

  registerSync = (groupKey: string, id: string, ref: HTMLElement) => {
    if (!this.syncGroup.has(groupKey)) {
      this.syncGroup.set(groupKey, [])
    }

    const keys = this.syncGroup.get(groupKey)

    if (!keys) {
      return
    }

    keys.push({
      id,
      element: ref,
    })
  }

  onScroll = ({ element, group, id }: { element: HTMLElement; group: string; id: string }) => {
    const scrollSyncTargetAttr = 'data-scroll-sync-target'
    const keys = this.syncGroup.get(group)

    if (!keys) {
      return
    }

    if (element.hasAttribute(scrollSyncTargetAttr)) {
      element.removeAttribute(scrollSyncTargetAttr)
      return
    }

    keys.forEach((key) => {
      if (key.id === id) {
        return
      }

      if (key.element.scrollTop === element.scrollTop) {
        return
      }

      key.element.setAttribute(scrollSyncTargetAttr, '')
      key.element.scrollTop = element.scrollTop
    })
  }

  unregisterSync = (groupKey: string, id: string) => {
    if (!this.syncGroup.has(groupKey)) {
      return
    }

    const refs = this.syncGroup.get(groupKey)

    if (!refs) {
      return
    }

    let index = 0

    for (; index < refs.length; index++) {
      if (refs[index].element.id === id) {
        break
      }
    }

    if (index === refs.length) {
      return
    }

    refs?.splice(index, 1)
  }
}

export const scrollSyncUtils = new ScrollSyncUtils()
